export const enum EventNames {
    NotificationCounterUpdateRequest = 'notifications:counter:request',
    // обновлен счетчик уведомлений
    NotificationCounterUpdated = 'notifications:counter'
};